import { checkChanged } from "./checkChanged";
import { ITlfActionUpdateTlfComment, TlfContextProps, UPDATE_TLF_COMMENT } from "./interface";

/**
 * Inserts or replaces a comment on the current TLF item.
 *
 * @param state - Current TLF context state.
 * @param action - Update-comment action containing the latest comment payload.
 * @returns Updated state with the supplied comment persisted on the active TLF.
 */
export const tlf_updateTlfComment = (
  state: TlfContextProps,
  action: ITlfActionUpdateTlfComment,
): TlfContextProps => {
  const newState = { ...state };

  if (!newState.tlfData) {
    throw new Error(`tlfContextReducer: ${UPDATE_TLF_COMMENT}: TLF data not set`);
  }

  newState.tlfData = {
    ...newState.tlfData,
    comments: [
      ...newState.tlfData.comments.filter((comment) => comment.id !== action.comment.id),
      action.comment,
    ],
  };
  newState.forcePushToParent = true;
  checkChanged(newState);

  return newState;
};
